import React from 'react';
import { 
  Crown, 
  Shield, 
  Cloud, 
  Smartphone, 
  Video, 
  Headphones,
  ArrowRight 
} from 'lucide-react';

const Services = ({ openModal }) => {
  const services = [
    {
      id: 'vcto',
      icon: Crown,
      title: 'vCTO & IT Strategy',
      description: 'Virtual Chief Technology Officer services providing executive-level technology strategy, roadmap development, and IT governance.',
      gradient: 'gradient-blue',
    },
    {
      id: 'cybersecurity',
      icon: Shield,
      title: 'Cybersecurity & Compliance',
      description: 'Comprehensive security assessments, SOC2/GDPR compliance, vulnerability management, and incident response planning.',
      gradient: 'bg-gradient-to-r from-logo-darkblue to-logo-teal',
    },
    {
      id: 'cloud',
      icon: Cloud,
      title: 'Cloud & Infrastructure',
      description: 'Cloud migration, optimization, and management across AWS, Azure, and GCP. Infrastructure design for scalability.',
      gradient: 'bg-gradient-to-r from-logo-lightblue to-logo-teal',
    },
    {
      id: 'mobile',
      icon: Smartphone,
      title: 'Web & Mobile Applications',
      description: 'Custom web and mobile application development, UX/UI design, and digital transformation solutions.',
      gradient: 'bg-gradient-to-r from-logo-green to-logo-green3',
    },
    {
      id: 'cctv',
      icon: Video,
      title: 'CCTV & Physical Security',
      description: 'Design and implementation of comprehensive CCTV systems, access control, and integrated physical security solutions.',
      gradient: 'bg-gradient-to-r from-logo-yellow to-logo-green',
    },
    {
      id: 'support',
      icon: Headphones,
      title: 'IT Support & Managed Services',
      description: '24/7 IT support, helpdesk services, network management, and proactive monitoring for uninterrupted operations.',
      gradient: 'bg-gradient-to-r from-logo-teal to-logo-green3',
    },
  ];

  return (
    <section id="services" className="py-16 sm:py-20 bg-gradient-to-b from-blue-50 to-green-50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-logo-navy mb-4">
            Our Core Services
          </h2>
          <p className="text-gray-600 max-w-3xl mx-auto text-base sm:text-lg">
            Click on any service to learn more about how we can help your business.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              onClick={() => openModal(service.id)}
              className="bg-white service-card p-6 sm:p-8 rounded-xl shadow-md border border-gray-100 cursor-pointer
                         hover:transform hover:-translate-y-2 transition-all duration-300"
            >
              <div className={`w-12 h-12 sm:w-14 sm:h-14 ${service.gradient} rounded-lg flex items-center justify-center mb-4 sm:mb-6`}>
                <service.icon className="text-white" size={24} />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-logo-navy mb-2 sm:mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 text-sm sm:text-base mb-4">
                {service.description}
              </p>
              <button className="text-logo-darkblue font-medium flex items-center hover:text-logo-lightblue text-sm sm:text-base">
                Learn More <ArrowRight size={16} className="ml-2" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;